import { all, call, delay, put, takeLatest } from 'redux-saga/effects'
import { IActionLoadConfig, loadConfigFile, setConfig } from '../actions/config'
import { loadCalendars } from '../actions/event'
import { CONFIG_LOAD_FILE } from '../constants/ActionTypes'
import { fetchFile } from '../services/axios'
import { IConfig, parseCalendars, parseDevice } from '../services/configParser'
import hashParser from '../services/hashParser'

function* runApp() {
  const settings = yield call(hashParser)
  yield put(loadConfigFile(settings))
}

function* loadConfig(action: IActionLoadConfig) {
  const { configFile, configJson, deviceId, updateInterval, eventInterval, errorRetryInterval } = action.settings
  const delayInterval = updateInterval * 60 * 1000

  if (!configFile && !configJson) {
    console.error('No config file specified.')
  }

  if (!deviceId) {
    console.error('No device ID was specified.')
  }

  while ((configFile || configJson) && deviceId) {
    try {
      // tslint:disable-next-line:no-any
      let configData: IConfig
      if (configFile) {
        const response = yield call(fetchFile, configFile)
        configData = response.data
      } else {
        configData = yield JSON.parse(configJson)
      }

      const device = yield call(parseDevice, configData, deviceId)
      const calendars = yield call(parseCalendars, configData.calendars)

      delete action.settings.configFile
      delete action.settings.updateInterval
      delete action.settings.eventInterval
      delete action.settings.errorRetryInterval
      delete action.settings.deviceId

      yield put(setConfig({ ...action.settings, device }))
      yield put(loadCalendars(calendars, eventInterval, action.settings, device))

      yield delay(delayInterval)
    } catch (e) {
      const retryIntervalMs = errorRetryInterval * 1000

      console.error(e)
      console.log(`Retry in ${errorRetryInterval} seconds...`)

      yield delay(retryIntervalMs)
    }
  }
}

export function* configSaga() {
  yield all([
    takeLatest(CONFIG_LOAD_FILE, loadConfig),
    runApp(),
  ])
}
